<div class="mt-2 text-end">
    {{ 'Showing' | translate }}
    {{ itemCount > 0 ? (activePage - 1) * pageSize + 1 : 0 }}
    {{ 'to' | translate }}
    {{ itemCount > activePage * pageSize ? activePage * pageSize : itemCount }}
    {{ 'of' | translate }}
    {{ itemCount }}
    {{ 'entries' | translate }}
</div>
